import throttle from 'lodash/throttle';
import debounce from 'lodash/debounce';

export const handleWindowScrollDirection = (
  scrollUpCallback,
  scrollDownCallback,
  waitDuration = 200
) => {
  let lastScrollTop = 0;
  let isClickTriggerScroll = false;

  document.addEventListener('click', (event) => {
    isClickTriggerScroll = event.target.hasAttribute('data-anchor');

    if (isClickTriggerScroll) {
      scrollDownCallback(false);
    }
  });

  const resetClickTriggerScroll = debounce(() => {
    isClickTriggerScroll = false;
  }, waitDuration);

  window.addEventListener(
    'scroll',
    throttle(() => {
      const newScrollTop = window.pageYOffset;
      const isScrollDown = lastScrollTop >= 0 && lastScrollTop <= newScrollTop;

      if (!isClickTriggerScroll) {
        if (isScrollDown) {
          scrollDownCallback();
        } else {
          scrollUpCallback();
        }
      }

      lastScrollTop = newScrollTop;

      resetClickTriggerScroll();
    }),
    waitDuration
  );
};
